<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'print-pdf',
  props: {
    autoPrintPreview: {
      type: Boolean,
      default: false
    },

    plants: {
      type: Array
    },

    totalLabel: {
      type: Number
    },

    totalBarcodes: {
      type: Number
    }
  },
  data() {
    return {
      windowRef: null
    }
  },
  watch: {
    open(newOpen) {
      if (newOpen) {
        this.openPortal()
      } else {
        this.closePortal()
      }
    }
  },
  methods: {
    openPortal() {
      this.windowRef = window.open('about:blank')
      this.windowRef.addEventListener('beforeunload', this.closePortal)
      // magic!
      this.windowRef.document.title = window.document.title
      this.windowRef.document.body.appendChild(this.$el)

      this.timeIntervalRef = setInterval(() => {
        this.handleAutoPrintLabel()
      }, 100)
    },

    handleAutoPrintLabel() {
      if (this.plants && this.windowRef.document.querySelector('body div div').childElementCount === this.plants.length + 1) {
        clearInterval(this.timeIntervalRef)

        setTimeout(() => {
          this.windowRef.print()
        }, 500)
      }
      if (this.plants && this.windowRef.document.querySelector('body .vs-card--content').childElementCount === Math.ceil(this.plants.length / 2)) {
        clearInterval(this.timeIntervalRef)

        setTimeout(() => {
          this.windowRef.print()
        }, 500)
      }

      if (this.totalBarcodes && this.windowRef.document.querySelector('body div div').childElementCount === this.totalBarcodes + 1) {
        clearInterval(this.timeIntervalRef)

        setTimeout(() => {
          this.windowRef.print()
        }, 500)
      }

      if (this.totalLabel && this.windowRef.document.querySelector('body  .vs-card--content').childElementCount === Math.ceil(this.totalLabel / 2)) {
        clearInterval(this.timeIntervalRef)

        setTimeout(() => {
          this.windowRef.print()
        }, 500)
      }
    },
    closePortal() {
      if (this.windowRef) {
        this.windowRef.close()
        this.windowRef = null
        this.$emit('close')
      }
    }
  },
  mounted() {
    this.openPortal()
  },
  beforeDestroy() {
    if (this.windowRef) {
      this.closePortal()
    }
  }
}
</script>
